//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MetadadosExtensao from './MetadadosExtensao';
import MetadadosCampoDinamicoAutocomplete from './campos-dinamicos/MetadadosCampoDinamicoAutocomplete';
import MetadadosCampoDinamicoTexto from './campos-dinamicos/MetadadosCampoDinamicoTexto';
import MetadadosCampoDinamicoDinheiro from './campos-dinamicos/MetadadosCampoDinamicoDinheiro';
import MetadadosCampoDinamicoBoolean from './campos-dinamicos/MetadadosCampoDinamicoBoolean';
import MetadadosCampoDinamicoData from './campos-dinamicos/MetadadosCampoDinamicoData';
import MetadadosCampoDinamicoHora from './campos-dinamicos/MetadadosCampoDinamicoHora';
import MetadadosCampoDinamicoNumerico from './campos-dinamicos/MetadadosCampoDinamicoNumerico';
import MetadadosCampoDinamicoPercentual from './campos-dinamicos/MetadadosCampoDinamicoPercentual';
import MetadadosCampoDinamicoMultiplaEscolha from './campos-dinamicos/MetadadosCampoDinamicoMultiplaEscolha';
import MetadadosCampoDinamicoLista from './campos-dinamicos/MetadadosCampoDinamicoLista';
import MetadadosCampoDinamicoCheckbox from './campos-dinamicos/MetadadosCampoDinamicoCheckbox';
import MetadadosCampoDinamicoListaCheckbox from './campos-dinamicos/MetadadosCampoDinamicoListaCheckbox';

export default {
  props: {
    campoExtensao: {
      type: Boolean,
      default: false,
    },
    objeto: Object,
    metadados: {
      type: Object,
      required: true,
    },
    ignoraObrigatorios: {
      type: Boolean,
      default: false,
    },
    ignoraFiltroRecursivo: {
      type: Boolean,
      default: false,
    },
    novoCadastro: {
      type: Boolean,
      default: false,
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    filtroRapido: {
      type: Boolean,
      default: false,
    },
    grupoAtivo: {
      type: Boolean,
      default: false,
    },
    getValoresDependencias: {
      type: Function,
      default: () => [],
    },
    exibeLoadingOverlay: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MetadadosCampoDinamicoListaCheckbox,
    MetadadosCampoDinamicoCheckbox,
    MetadadosExtensao,
    MetadadosCampoDinamicoAutocomplete,
    MetadadosCampoDinamicoTexto,
    MetadadosCampoDinamicoDinheiro,
    MetadadosCampoDinamicoBoolean,
    MetadadosCampoDinamicoData,
    MetadadosCampoDinamicoHora,
    MetadadosCampoDinamicoNumerico,
    MetadadosCampoDinamicoPercentual,
    MetadadosCampoDinamicoMultiplaEscolha,
    MetadadosCampoDinamicoLista,
  },
  computed: {
    campoAutocomplete() {
      return !this.metadados.campoExtensao &&
        this.metadados.async != null &&
        (this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA' ||
        this.metadados.tipoCampo === 'LISTA');
    },
    campoTexto() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'TEXTO';
    },
    campoCheckbox() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'CHECKBOX';
    },
    campoListaCheckbox() {
      return !this.metadados.campoExtensao &&
        (this.metadados.tipoCampo === 'LISTA_CHECKBOX'
          || (this.filtroRapido &&
            (this.metadados.tipoCampo === 'LISTA' ||
              this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA')));
    },
    campoDinheiro() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'DINHEIRO';
    },
    campoBoolean() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'BOOLEAN';
    },
    campoData() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'DATA';
    },
    campoHora() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'HORA';
    },
    campoNumerico() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'NUMERICO';
    },
    campoPercentual() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'PERCENTUAL';
    },
    campoMultiplaEscolha() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA' &&
        !this.filtroRapido;
    },
    campoLista() {
      return !this.metadados.campoExtensao &&
        this.metadados.tipoCampo === 'LISTA' &&
        !this.filtroRapido;
    },
  },
  methods: {
    filtraAmostragemRecursiva(metadadosExtensao) {
      this.$emit('MetadadosExtensao_FiltraAmostragemRecursiva', metadadosExtensao);
    },
    refresh() {
      this.$forceUpdate();
      if (this.$refs.componente) {
        this.$refs.componente.refresh();
      }
    },
    valorAlterado(valor) {
      const label = this.metadados.label || this.metadados.labelCampo;
      const { desAtributos } = this.metadados;
      const alteracao = {
        valor,
        label,
      };
      if (this.metadados.dependentes) {
        alteracao.dependentes =
          this.metadados.dependentes;
      } else {
        alteracao.dependentes =
          desAtributos ? desAtributos.dependentes || [] : [];
      }

      this.$emit('MetadadosComponenteDinamico_valorAlterado', alteracao);
    },
    abrirCadastro(metadados) {
      this.$emit('MetadadosComponenteDinamico_abrirCadastro', metadados);
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/MetadadosComponenteDinamico.vue?vue&type=script&lang=js&